"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.configurePercent = exports.configureOverTimeComparison = void 0;
var tslib_1 = require("tslib");
// (C) 2019-2021 GoodData Corporation
var forEach_1 = tslib_1.__importDefault(require("lodash/forEach"));
var set_1 = tslib_1.__importDefault(require("lodash/set"));
var isEmpty_1 = tslib_1.__importDefault(require("lodash/isEmpty"));
var includes_1 = tslib_1.__importDefault(require("lodash/includes"));
var isEqual_1 = tslib_1.__importDefault(require("lodash/isEqual"));
var cloneDeep_1 = tslib_1.__importDefault(require("lodash/cloneDeep"));
var sdk_ui_1 = require("@gooddata/sdk-ui");
var bucket_1 = require("../constants/bucket");
var bucketHelper_1 = require("./bucketHelper");
var bucketRules_1 = require("./bucketRules");
function getTypeOfDerivedToKeep(supportedTypes, appliedType) {
    return isEmpty_1.default(supportedTypes) || isEqual_1.default(supportedTypes, [sdk_ui_1.OverTimeComparisonTypes.NOTHING])
        ? sdk_ui_1.OverTimeComparisonTypes.NOTHING
        : appliedType;
}
function configureOverTimeComparison(extendedReferencePoint, weekFiltersEnabled) {
    var newExtendedReferencePoint = cloneDeep_1.default(extendedReferencePoint);
    var buckets = newExtendedReferencePoint.buckets, filters = newExtendedReferencePoint.filters, uiConfig = newExtendedReferencePoint.uiConfig;
    var supportedOverTimeComparisonTypes = uiConfig.supportedOverTimeComparisonTypes;
    var appliedComparisonType = bucketHelper_1.getComparisonTypeFromFilters(filters);
    var isSelectedComparisonSupportedByVis = includes_1.default(supportedOverTimeComparisonTypes, appliedComparisonType);
    var derivedOfTypeToKeep = getTypeOfDerivedToKeep(supportedOverTimeComparisonTypes, appliedComparisonType);
    var comparisonOverTimeAllowed = bucketRules_1.isComparisonOverTimeAllowed(buckets, filters, weekFiltersEnabled);
    var originalBuckets = cloneDeep_1.default(buckets);
    forEach_1.default(buckets, function (bucket) {
        var newItems = bucket.items;
        if (!comparisonOverTimeAllowed) {
            newItems = bucketHelper_1.filterOutArithmeticMeasuresFromDerived(newItems, originalBuckets);
            newItems = bucketHelper_1.filterOutDerivedMeasures(newItems);
        }
        if (!isSelectedComparisonSupportedByVis) {
            newItems = bucketHelper_1.filterOutIncompatibleArithmeticMeasures(newItems, originalBuckets, derivedOfTypeToKeep);
            newItems = bucketHelper_1.keepOnlyMasterAndDerivedMeasuresOfType(newItems, derivedOfTypeToKeep);
        }
        bucket.items = newItems;
    });
    if (!bucketHelper_1.isComparisonAvailable(buckets, filters)) {
        newExtendedReferencePoint = bucketHelper_1.removeAllDerivedMeasures(newExtendedReferencePoint);
    }
    return newExtendedReferencePoint;
}
exports.configureOverTimeComparison = configureOverTimeComparison;
function removeShowInPercent(measure) {
    return set_1.default(measure, bucket_1.SHOW_IN_PERCENT, null);
}
function configurePercent(extendedReferencePoint, percentDisabled) {
    if (percentDisabled === void 0) { percentDisabled = false; }
    forEach_1.default(extendedReferencePoint.buckets, function (bucket) {
        var showInPercentEnabled = !percentDisabled &&
            bucketRules_1.isShowInPercentAllowed(extendedReferencePoint.buckets, extendedReferencePoint.filters, bucket.localIdentifier);
        if (!showInPercentEnabled) {
            bucket.items.forEach(function (measure) {
                if (measure.type === bucket_1.METRIC) {
                    removeShowInPercent(measure);
                }
            });
        }
        var bucketUiConfig = extendedReferencePoint.uiConfig.buckets[bucket.localIdentifier];
        if (bucketUiConfig.accepts.indexOf(bucket_1.METRIC) >= 0) {
            bucketUiConfig.isShowInPercentEnabled = showInPercentEnabled;
        }
    });
    return extendedReferencePoint;
}
exports.configurePercent = configurePercent;
//# sourceMappingURL=bucketConfig.js.map